import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            I'm a <span className="purple">FullStack Developer</span> who loves <strong>untangling tech puzzles</strong> and <strong>getting projects moving fast</strong>. 
            With 3 years making websites and apps work smarter, I've helped clients in law, eco-tech, restaurants, and SaaS companies turn their ideas into reality.
            <br />
            <br />
            <strong>What I Bring to Your Team</strong>
            <br />
            🛠️ <strong>Core Tech Skills</strong>: React/Next.js frontends, Nest.js backends, AWS cloud setups.
            <br />
            🔄 <strong>System Connector</strong>: Special talent for making different tech pieces work together smoothly.
            <br />
            🚀 <strong>Project Rescuer</strong>: Great at finding stuck points and clearing them.
            <br />
            🤝 <strong>Team Player</strong>: Equally comfortable working solo or with teams.
            <br />
            <br />
            <strong>Why Work With Me?</strong>
            <br />
            🗣️ <strong>No Tech Jargon</strong>: I explain complex things in plain English.
            <br />
            🏃‍♂️ <strong>Fast Starter</strong>: Get up to speed with your project in days, not weeks.
            <br />
            🔧 <strong>Fix-It Focus</strong>: Love taking over tricky projects and making them work.
            <br />
            💡 <strong>Problem Solver</strong>: Turn challenges into opportunities quickly.
            <br />
            <br />
            {/* Apart from coding, some other activities that I love to do!
            <ul>
              <li>🚲 Cycling</li>
              <li>💻 Writing Tech Blogs</li>
              <li>🌍 Travelling</li>
            </ul> */}
          </p>

          <p style={{ color: "rgb(155 126 172)" }}>
            "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn."{" "}
          </p>
          <footer className="blockquote-footer">Alvin Toffler</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;